import './App.scss';
import './index.scss';

import ReactDOM from 'react-dom/client';
import App from 'App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import PWAPrompt from 'react-ios-pwa-prompt';
import swDev from 'swDev';
import PushNotificationLayout from 'utils/PushNotificationLayout';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js', {
        scope: '/firebase-cloud-messaging-push-scope',
      })
      .then((registration) => {
        // console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
// if ('serviceWorker' in navigator && 'PushManager' in window) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then((registration) => {
//         console.log('Service Worker registered with scope:', registration.scope);

//         // Handle push notification subscription or other logic here
//       })
//       .catch((error) => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <PushNotificationLayout>
      <App />
      {/* <PWAPrompt /> */}
    </PushNotificationLayout>
  </>
);
document.body.classList.add('site-set');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// /service-worker.js (workbox) is intentionally not registered: /sw.js owns
// scope "/" for Netcore web push and app caching.
// serviceWorkerRegistration.register();
swDev();
